import apiClient from '../http-common'

export const AUTH_ENDPOINT = '/auth'

export const initiateLogin = (email, password) =>
  apiClient.post(`${AUTH_ENDPOINT}/login/`, { email, password })

export const refreshAuth = (token) =>
  apiClient.post(`${AUTH_ENDPOINT}/refresh/`, { refresh: token })
